import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getAssetHyperlinkHtml = ((_node: Block | Inline, _next: Next) =>
  // I leave it here as a possible future implementation.
  // `<a href="https://google.com" target="_blank" rel="noreferrer noopener">${next(
  //   node.content,
  // )} </a>`
  'The Inline Asset Hyperlink is not supported yet by this feature.') as NodeRenderer;
